import React, { useContext } from 'react'
import './index.scss'
import { ClickableItemCard } from '@Components/Cards/ClickableItemCard'
import Navigation from '@App/navigation'
import { NavLink, useNavigate } from 'react-router'
import { StoresContext } from '@App/contexts'
import { RightsholderContact } from '@Entities/rightsholder/rightsholder-contact'
import { getRightsholderContactType } from '@App/helpers/rightsholder-contact-type'

interface ContactTableProps {
    rightsholderContacts: RightsholderContact[]
}

/**
 * TODO This component needs unit testing once DI has been removed
 *
 * @param props
 * @constructor
 */
const RightsholderContactTable = (props: ContactTableProps) => {
    const navigate = useNavigate()
    const { popupStore, contactStore } = useContext(StoresContext)

    const handleOnClick = async (event: React.MouseEvent) => {
        if (event.currentTarget.id) {
            const selectedContact = props.rightsholderContacts.find((contact) => contact.id === event.currentTarget.id)
            if (selectedContact) {
                contactStore.setRightsholderContact(selectedContact)
            } else {
                popupStore.setAlertData('Unable To Find Rightsholder Contact', true)
                navigate('/')
            }
        }
    }

    return (
        <>
            {props.rightsholderContacts.map((contact: RightsholderContact) => (
                <ClickableItemCard
                    className="rightsholder-contact-item"
                    path={Navigation.rightholder.maintenance.contactInformation(contact.ipId as number, contact.id)}
                    id={contact.id}
                    handleOnClick={handleOnClick}
                    key={contact.id}
                >
                    <>
                        <div className="left-data">
                            <div className="contact-title">
                                <NavLink
                                    to={Navigation.rightholder.maintenance.contactInformation(
                                        contact.ipId as number,
                                        contact.id
                                    )}
                                    id={contact.id}
                                    /*
                                     * These e.stopPropagation() calls are apparently hacks enabled to
                                     * keep the history working properly. I currently don't know a
                                     * better solution - Dan
                                     */
                                    onClick={(e) => e.stopPropagation()}
                                    onMouseDown={(e) => {
                                        e.stopPropagation()
                                        return handleOnClick(e)
                                    }}
                                    className="title-link"
                                >
                                    {contact.firstName} {contact.lastName}
                                </NavLink>
                            </div>
                        </div>
                        <div className="middle-data">
                            Email: <strong>{contact.email}</strong>
                        </div>
                        <div className="right-data">
                            Contact Type:{' '}
                            <strong>{getRightsholderContactType(contact.rightsholderContactTypeId)}</strong>
                        </div>
                    </>
                </ClickableItemCard>
            ))}
        </>
    )
}

export default RightsholderContactTable
